function Tooltip({
  children,
  tooltipText
}) {
  return (
    <div className="vr-tooltip">
      {children}
      <span className="vr-tooltip-text">{tooltipText}</span>
    </div>
  )
};

export default Tooltip;


